<template>
    <tr v-if="sortedGroup[0]">
        <td data-label="Fecha/Hora">
            <div class="data-wrapper">
                {{ sortedGroup[0].createdAt }}
            </div>
        </td>
        <td data-label="Usuario">
            <div class="user">
                <div class="data-wrapper" @mouseleave="resetScroll($event)">
                    <span v-if="sortedGroup[0].user">{{
                        sortedGroup[0].user.email
                    }}</span>
                    <span
                        v-if="sortedGroup[0].organization"
                        class="user-entity"
                        >{{ sortedGroup[0].organization.businessName }}</span
                    >
                </div>
            </div>
        </td>
        <td data-label="IP">
            <div class="data-wrapper" @mouseleave="resetScroll($event)">
                {{ sortedGroup[0].ip }}
            </div>
        </td>
        <td data-label="Dispositivo">
            <div class="data-wrapper" @mouseleave="resetScroll($event)">
                {{ sortedGroup[0].userAgent }}
            </div>
        </td>
        <td data-label="Ruta">
            <div class="data-wrapper" @mouseleave="resetScroll($event)">
                {{ sortedGroup[0].referer }}
            </div>
        </td>
        <td data-label="Parámetros">
            <span class="infotip top" :class="{ active: showParams }">
                <button
                    class="infotip__host"
                    aria-controls="infotip-overlay"
                    aria-expanded="true"
                    aria-label="Help"
                    type="button"
                    @click="showParams = !showParams"
                >
                    <div class="log-params">
                        {{ sortedGroup[0].body }}
                    </div>
                </button>
                <span class="infotip__live-region" aria-live="off">
                    <div class="infotip__overlay" id="infotip-overlay">
                        <h4>Parámetros</h4>
                        <div class="code">
                            <template v-for="log in sortedGroup">
                                <div :key="log.id">
                                    <strong>{{ log.action }}</strong>
                                    <br />
                                    {{ log.createdAt }}
                                    <br />
                                    {{ log.body }}
                                    <br />
                                </div>
                            </template>
                        </div>
                    </div>
                </span>
            </span>
        </td>
    </tr>
</template>

<script>
import AuditLogsRow from "@/components/admin/AuditLogsRow.vue";

export default {
    name: "audit-logs-group-row",
    props: {
        group: {
            type: Array,
            required: true,
        },
    },
    components: {
        AuditLogsRow,
    },
    data() {
        return {
            showParams: false,
            showLogs: false,
        };
    },
    created() {
        window.addEventListener("click", this.close);
    },
    beforeDestroy() {
        window.removeEventListener("click", this.close);
    },
    computed: {
        sortedGroup() {
            this.group.forEach((log) => {
                let date = Date.parse(log.createdAt);
                log.createdAt = new Date(date).toLocaleString();
                log.date = new Date(date);
                log.body = log.body.replace(/\\n/g, "");
            });
            this.group.sort((a, b) => {
                return a.date - b.date;
            });
            return this.group;
        },
    },
    methods: {
        close(e) {
            if (!this.$el.contains(e.target)) {
                this.showParams = false;
            }
        },
        resetScroll(event) {
            event.target.scrollLeft = 0;
        },
    },
};
</script>
